<template>
  <div class="mb-16">
    <h4>{{ $t("stats.student.sidebar.map") }}</h4>
    <LearningMap
      class="mt-4 py-6 shadow bg-white rounded"
      :userId="studentId"
      :courseId="courseId"
      :type="'STATS_LEARNING_MAP'"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "studentMap",
  props: {
    courseId: [String],
    studentId: [String],
  },
});
</script>
